module.exports = new __parcel__URL__("periscope-page-stable.tpl.e6f50fff.svg").toString();